import React from "react";
import _ from "lodash";
import { NetworkAPI } from "apis";
import ModalWrapper from "components/common/ModalWrapper";
import CurrencySelector from "components/common/CurrencySelector";
import NumberFormat from "components/common/NumberFormat";
import ModalFooter from "components/common/ModalFooter";
import LoadingUI from "components/common/LoadingUI";
import { inputClass } from "helpers/StyleClass";
import { MESSAGE } from "constants/Message";

class UpdateAdServingCostModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      algoCostCpm: null,
      costCpm: null,
      freeQuota: null,
      costCpmCurrency: null,

      isLoading: false,
      isSaving: false,
      msg: [],
    };

    this.handleConfirm = this.handleConfirm.bind(this);
  }

  async componentDidMount() {
    const {
      network: { networkId },
    } = this.props;

    try {
      this.setState({ isLoading: true });
      const [info] = await NetworkAPI.getNetworks({
        networkIds: [networkId],
      });

      this.setState({
        isLoading: false,
        algoCostCpm: info.algoCostCpm,
        costCpm: info.adServingCost.costCpm,
        freeQuota: info.adServingCost.freeQuota,
        costCpmCurrency: info.adServingCost.costCpmCurrency,
      });
    } catch (error) {
      this.setState({
        msg: [error.toString(), MESSAGE.ERROR],
      });
      return;
    }
  }

  async handleConfirm() {
    try {
      const { network, updateData } = this.props;
      const { algoCostCpm, costCpm, freeQuota, costCpmCurrency } = this.state;
      if (
        _.isNil(algoCostCpm) ||
        _.isNil(costCpm) ||
        _.isNil(freeQuota) ||
        _.isNil(costCpmCurrency) ||
        algoCostCpm === "" ||
        costCpm === "" ||
        freeQuota === "" ||
        costCpmCurrency === ""
      ) {
        throw "Missing 'Algo Cost CPM', 'Cost CPM', or 'Free Quota or 'costCpmCurrency'!";
      }

      const params = {
        networkId: network.networkId,
        algoCostCpm,
        costCpm,
        freeQuota,
        costCpmCurrency,
      };

      this.setState({
        isSaving: true,
        msg: [],
      });

      const result = await NetworkAPI.updateNetworkAdServingCost(params);

      this.setState({
        isSaving: false,
        msg: ["Network updated!", MESSAGE.SUCCESS],
      });

      if (updateData) {
        updateData(result.gamNetwork);
      }
    } catch (error) {
      this.setState({
        msg: [error.toString(), MESSAGE.ERROR],
      });
      return;
    }
  }

  render() {
    const { network, handleClose } = this.props;
    const {
      algoCostCpm,
      costCpm,
      freeQuota,
      costCpmCurrency,
      msg,
      isLoading,
      isSaving,
    } = this.state;

    return (
      <ModalWrapper
        isOpen={true}
        showCloseFooter={false}
        width="40%"
        title={`${network.networkId} ${network.name}`}
      >
        {!algoCostCpm || !costCpm || !freeQuota || !costCpmCurrency ? (
          <>{isLoading && <LoadingUI iconOnly={true}></LoadingUI>}</>
        ) : (
          <div className="bg-gray-200 px-6 py-4">
            <div className="mb-4 w-1/2">
              <label className="font-semibold text-gray-800">
                Algo Cost CPM (in USD)
              </label>
              <div>
                <input
                  type="number"
                  step="0.000001"
                  className={inputClass}
                  value={algoCostCpm}
                  onChange={(e) =>
                    this.setState({
                      algoCostCpm: e.target.value,
                    })
                  }
                ></input>
              </div>
            </div>

            <div className="mb-4">
              <label className="font-semibold text-gray-800">
                Cost CPM Currency
              </label>
              <div>
                <CurrencySelector
                  selectedCurrency={costCpmCurrency}
                  handleCurrencyChanged={(currency) =>
                    this.setState({ costCpmCurrency: currency })
                  }
                ></CurrencySelector>
              </div>
            </div>

            <div className="mb-4 w-1/2">
              <label className="font-semibold text-gray-800">
                Cost CPM (in {costCpmCurrency})
              </label>
              <div>
                <input
                  type="number"
                  step="0.000001"
                  className={inputClass}
                  value={costCpm}
                  onChange={(e) =>
                    this.setState({
                      costCpm: e.target.value,
                    })
                  }
                ></input>
              </div>
            </div>

            <div className="mb-4 w-1/2">
              <label className="font-semibold text-gray-800">
                Free Quota (
                <NumberFormat value={freeQuota} format="0,0a"></NumberFormat>)
              </label>
              <div>
                <input
                  type="number"
                  className={inputClass}
                  value={freeQuota}
                  min="0"
                  onChange={(e) =>
                    this.setState({
                      freeQuota: e.target.value,
                    })
                  }
                ></input>
              </div>
            </div>
            <ModalFooter
              msg={msg}
              confirmText="Update Network"
              isLoading={isSaving}
              onClose={handleClose}
              onCancel={handleClose}
              onConfirm={this.handleConfirm}
            ></ModalFooter>
          </div>
        )}
      </ModalWrapper>
    );
  }
}
export default UpdateAdServingCostModal;
